import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=2250a9bd&"
import script from "./CreateForm.vue?vue&type=script&lang=ts&"
export * from "./CreateForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports